import { useTranslation } from 'react-i18next';

import { Card, CardContent, Typography } from '@mui/joy';

import { DroneHeartBeat } from '../../models/DroneProfile/DroneProfile.model';

interface Props {
  heartbeat: DroneHeartBeat;
}

export default function MemoryUsageCard({ heartbeat}: Props) {
  const { t } = useTranslation();
  const mem = heartbeat.memory;

  if (!mem?.total || !mem?.available) {
    return (
      <Card color="neutral" variant="soft">
        <CardContent>
          <Typography gutterBottom level="title-md">
            {t('heartbeat.memory.title')}
          </Typography>
          <p className="text-sm text-center text-gray-500">
            {t('heartbeat.memory.no_info')}
          </p>
        </CardContent>
      </Card>
    );
  }

  const used = mem.total - mem.available;
  const usedPercent = (used / mem.total) * 100;

  return (
    <Card color="neutral" variant="soft">
      <CardContent>
        <Typography gutterBottom level="title-md">
          {t('heartbeat.memory.title')}
        </Typography>

        <div className="flex justify-between mb-2 mt-3">
          <span className="text-sm text-gray-600">{t('heartbeat.memory.used')}</span>
          <span className="text-sm font-medium">
            {used.toFixed(0)} MB / {mem.total.toFixed(0)} MB
          </span>
        </div>

        <div className="w-full bg-gray-200 rounded-full h-4 mb-2 relative">
          <div
            className="bg-purple-500 h-4 rounded-full transition-all duration-300 ease-in-out"
            style={{ width: `${usedPercent}%` }}
          />
          <span className="absolute inset-0 text-xs flex items-center justify-center text-white font-semibold">
            {usedPercent.toFixed(1)}%
          </span>
        </div>

        <div className="flex justify-between text-sm text-gray-600">
          <span>{t('heartbeat.memory.available')}: {mem.available.toFixed(0)} MB</span>
          <span>{t('heartbeat.memory.total')}: {mem.total.toFixed(0)} MB</span>
        </div>
      </CardContent>
    </Card>
  );
}
